import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import BottomSheet from "./BottomSheet";
import css from "./partnersMobile.module.css";

// Values match the desktop DropDown at ChannelPartner.jsx:2067 exactly —
// they are passed straight through to getCp/getFos as drpDownSelectedVal,
// so the strings must not be reworded.
const SORT_OPTIONS = [
  "Name Ascending",
  "Name Descending",
  "Latest First",
  "Oldest First",
];

export default function SortSheet({ open, value, onSelect, onClose }) {
  return (
    <BottomSheet open={open} title="Sort by" onClose={onClose}>
      {SORT_OPTIONS.map((option) => (
        <button
          key={option}
          type="button"
          className={`${css.sheetOption} ${
            value === option ? css.sheetOptionSelected : ""
          }`}
          onClick={() => {
            onSelect(option);
            onClose();
          }}
        >
          <span style={{ flex: 1 }}>{option}</span>
          {value === option && <CheckIcon sx={{ fontSize: 20 }} />}
        </button>
      ))}
    </BottomSheet>
  );
}
